import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-sm font-medium opacity-90" }
const _hoisted_9 = { class: "text-lg md:text-xl font-bold truncate" }
const _hoisted_10 = { class: "text-xs md:text-sm opacity-80 truncate" }
const _hoisted_11 = { class: "bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto shadow-xl" }
const _hoisted_12 = { class: "p-6" }
const _hoisted_13 = { class: "flex items-center justify-between mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-heading font-semibold text-primary-800" }, " Garbage & Recycling ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 text-primary-600" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Service Provider "),
    /*#__PURE__*/_createElementVNode("p", null, "Johns Disposal Service"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "262-473-4700 | office@johnsdisposal.com")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, "Schedule"),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "Garbage:"),
        /*#__PURE__*/_createTextVNode(" Weekly on Mondays")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "Recycling:"),
        /*#__PURE__*/_createTextVNode(" Every other Monday")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Recycling Guidelines "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Single-stream recycling (all recyclables together)"),
      /*#__PURE__*/_createElementVNode("li", null, "Use blue/green lid cart"),
      /*#__PURE__*/_createElementVNode("li", null, "No plastic bags in recycling"),
      /*#__PURE__*/_createElementVNode("li", null, "Rinse containers before recycling")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Bulk Item Pickup (FREE) "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Up to 1 pickup per month (4 per year)"),
      /*#__PURE__*/_createElementVNode("li", null, "Call Johns Disposal to schedule"),
      /*#__PURE__*/_createElementVNode("li", null, "Furniture, appliances, carpet (4-ft. sections)"),
      /*#__PURE__*/_createElementVNode("li", null, "Up to 2 tires per pickup"),
      /*#__PURE__*/_createElementVNode("li", null, "Items must be under 50 lbs")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Drop-Off Center "),
    /*#__PURE__*/_createElementVNode("p", null, "4551 S 52nd Street (FREE for residents)"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Tue/Thu 2-7pm, Sat 7:30am-3:30pm")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Holiday Schedule "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Collection shifts one day later when holidays fall on weekdays. Observed: New Year's, Memorial Day, July 4th, Labor Day, Thanksgiving, Christmas. ")
  ])
], -1)

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showInfo = ref(false);

// Greenfield, WI - Johns Disposal
// Foxwood Crossing is in Collection Area "Monday A"
// Garbage pickup is every Monday
// Recycling is every other Monday (A weeks)

const PICKUP_DAY = 1; // Monday (0 = Sunday, 1 = Monday)

const getNextPickupDate = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  let daysUntilPickup = (PICKUP_DAY - dayOfWeek + 7) % 7;

  // If today is pickup day, return today. Otherwise, if pickup day passed this week, go to next week.
  if (daysUntilPickup === 0) {
    // Today is Monday - return today
  } else if (dayOfWeek > PICKUP_DAY) {
    // We're past Monday this week - jump to next Monday (7 days from last Monday)
    daysUntilPickup = 7 - dayOfWeek + PICKUP_DAY;
  }

  const nextPickup = new Date(today);
  nextPickup.setDate(today.getDate() + daysUntilPickup);
  return nextPickup;
};

const isRecyclingWeek = computed(() => {
  // Use a known recycling pickup date as reference
  // Foxwood Crossing: June 2, 2026 is confirmed recycling week
  const referenceRecyclingDate = new Date("2026-06-01"); // Monday - green week = recycling
  const nextPickup = getNextPickupDate();

  const weeksDiff = Math.floor(
    (nextPickup.getTime() - referenceRecyclingDate.getTime()) /
      (7 * 24 * 60 * 60 * 1000)
  );

  return weeksDiff % 2 === 0;
});

const pickupDay = computed(() => {
  const today = new Date();
  const nextPickup = getNextPickupDate();
  const daysUntil = Math.round(
    (nextPickup.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (daysUntil === 0) {
    return "Today";
  } else if (daysUntil === 1) {
    return "Tomorrow";
  } else {
    return "Monday"; // Just the day name - unambiguous
  }
});

const putOutReminder = computed(() => {
  const today = new Date();
  const nextPickup = getNextPickupDate();
  const daysUntil = Math.round(
    (nextPickup.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (daysUntil === 0) {
    return "Pickup day!";
  } else if (daysUntil === 1) {
    return "Put out tonight";
  } else if (daysUntil === 2) {
    return "Put out tomorrow night";
  } else {
    return "Put out Sunday night";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-xl p-3 md:p-4 shadow-soft overflow-hidden min-w-0", 
      _unref(isRecyclingWeek)
        ? 'bg-emerald-500 text-white'
        : 'bg-primary-700 text-white'
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center", _unref(isRecyclingWeek) ? 'bg-emerald-400' : 'bg-primary-600'])
      }, [
        (_unref(isRecyclingWeek))
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
      ], 2),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(isRecyclingWeek) ? "Garbage & Recycling" : "Garbage Only"), 1)
    ]),
    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(pickupDay)), 1),
    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(putOutReminder)), 1),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showInfo.value = true)),
      class: "mt-2 text-xs underline opacity-80 hover:opacity-100 transition-opacity"
    }, " Collection info → "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showInfo.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showInfo.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showInfo.value = false)),
                    class: "p-2 text-primary-400 hover:text-primary-600 transition-colors"
                  }, _hoisted_16)
                ]),
                _hoisted_17
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})